import { render, staticRenderFns } from "./PBFooter.vue?vue&type=template&id=03e7dd73&"
import script from "./PBFooter.vue?vue&type=script&lang=js&"
export * from "./PBFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports